export default __webpack_public_path__ + "static/media/settings.623f8e30.svg";